import { render } from "./Header.vue?vue&type=template&id=64d6c5f3"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=64d6c5f3&lang=scss"

import exportComponent from "D:\\Server\\Projects\\aurus-applications-support\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__